// extracted by mini-css-extract-plugin
module.exports = {"primaryEmailContainer":"styles_primaryEmailContainer__w0qb9","primaryEmailLabel":"styles_primaryEmailLabel__pxDsC","primaryEmailValue":"styles_primaryEmailValue__1NwIK"};